export const accessStatusLabels: Record<string, string> = {
  DEACTIVATED: "Conta desativada",
  HAS_ACCESS: "Com acesso",
  NO_ACCESS: "Sem acesso",
};

export const subscriptionStatusLabels: Record<string, string> = {
  COURTESY: "Cortesia",
  NO_SUBSCRIPTION: "Sem assinatura",
  CANCELLED: "Cancelada",
  POSSIBLY_OVERDUE: "Atrasadas",
  TRIAL: "Em teste",
  ACTIVE: "Ativa",
  EXPIRED: "Expirada",
};

export const providerLabels: Record<string, string> = {
  ASAAS: "Asaas",
  GOOGLE_PLAY: "Google Play",
  NONE: "Sem assinatura",
  UNKNOWN: "Desconhecido",
};

export function statusClass(status: string): string {
  return `status-${status.toLowerCase().replace(/_/g, "-")}`;
}
